const isMobile = window.matchMedia('(pointer:coarse)').matches;
export default isMobile;
